import { Link, useLocation } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

const routeLabels: Record<string, string> = {
  mot: "MOT Testing",
  servicing: "Car Servicing",
  diagnostics: "Diagnostics",
  "mechanical-repairs": "Mechanical Repairs",
  bodywork: "Bodywork",
  about: "About",
  contact: "Contact",
  book: "Request a Booking",
  gallery: "Gallery",
  reviews: "Reviews",
  areas: "Areas",
  blog: "Blog",
  services: "Services",
  "ev-hybrid-servicing": "EV & Hybrid Servicing",
  "air-con-regas": "Air Con Regas",
  privacy: "Privacy Policy",
  terms: "Terms & Conditions",
};

export function Breadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

  if (segments.length === 0 || segments[0] === "admin") return null;

  const crumbs = segments.map((seg, i) => {
    const path = "/" + segments.slice(0, i + 1).join("/");
    const label = routeLabels[seg] || seg.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    return { path, label };
  });

  return (
    <nav aria-label="Breadcrumb" className="bg-secondary/50 border-b border-border/30">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-2.5">
        <ol className="flex flex-wrap items-center gap-1 text-xs text-muted-foreground" itemScope itemType="https://schema.org/BreadcrumbList">
          <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <Link
              to="/"
              className="rounded-sm px-1 -mx-1 outline-none hover:text-foreground hover:underline underline-offset-4 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background transition-colors"
              itemProp="item"
            >
              <span itemProp="name">Home</span>
            </Link>
            <meta itemProp="position" content="1" />
          </li>
          {crumbs.map((crumb, i) => (
            <li key={crumb.path} className="flex items-center gap-1" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <ChevronRight className="h-3 w-3 text-muted-foreground" aria-hidden="true" />
              {i === crumbs.length - 1 ? (
                <span
                  className="font-medium text-foreground"
                  aria-current="page"
                  itemProp="name"
                >
                  {crumb.label}
                </span>
              ) : (
                <Link
                  to={crumb.path as any}
                  className="rounded-sm px-1 -mx-1 outline-none hover:text-foreground hover:underline underline-offset-4 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background transition-colors"
                  itemProp="item"
                >
                  <span itemProp="name">{crumb.label}</span>
                </Link>
              )}
              <meta itemProp="position" content={String(i + 2)} />
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
